import { render, staticRenderFns } from "./AddMovementForm.vue?vue&type=template&id=722a3748"
import script from "./AddMovementForm.vue?vue&type=script&lang=js"
export * from "./AddMovementForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports